/**
 * Extracts a comparable identity from a value.
 * For objects with an `id` property, returns the id. Otherwise returns the value itself.
 */
export const getValueId = <T>(val: T): unknown =>
	typeof val === "object" && val !== null && "id" in val ? (val as { id: string }).id : val;

/**
 * Computes the next value array after toggling an option on or off.
 * If the option is already selected, it's removed. Otherwise it's added.
 */
export const toggleValue = <T>(currentValue: T[], optionValue: T): T[] => {
	const optionId = getValueId(optionValue);
	const isSelected = currentValue.some((val) => getValueId(val) === optionId);
	return isSelected ? currentValue.filter((val) => getValueId(val) !== optionId) : [...currentValue, optionValue];
};

/**
 * Computes the next value array by appending an option.
 */
export const accumulateValue = <T>(currentValue: T[], optionValue: T): T[] => {
	return [...currentValue, optionValue];
};
